import invitationActions from './actionTypes';
import config from '../../../config/config';

const {
  REQUEST_INVITATIONS,
  RECIEVE_INVITATIONS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS
} = invitationActions;

function hasError(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors
  };
}

function fecthInvitations(token, isWebinar) {
  return fetch(`${config.URI}/api/v1/invitations?is_webinar=${isWebinar ? 1 : 0}`, {
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    if (!res.ok) {
      throw Error(res.statusText);
    } else {
      return res.json();
    }
  })
}

export function getInvitations(token, isWebinar) {
  return function(dispatch) {
    dispatch({ type: REQUEST_INVITATIONS });
    fecthInvitations(token, isWebinar).then(res => {
      if(res && res.status && res.status === 'success') {
        dispatch({ type: RECIEVE_INVITATIONS, invitations: res.data.invitations})
      } else if(res.errors) {
        dispatch(hasError(res.errors));
        console.log(res.errors);
      }
    })
  }
}

export function clearErrors() {
  return function(dispatch) {
    dispatch({ type: CLEAR_ERRORS });
  }
}


// WEBPACK FOOTER //
// src/routes/Invitations/actions/index.js